import React from "react";
import Draggable from "react-draggable";

export default class CustomTextDraggable extends React.Component {
  constructor(props) {
    super(props);
    this.nodeRef = React.createRef();
  }

  state = {
    controlledPosition: {
      x: this.props.textPosition.x,
      y: this.props.textPosition.y,
    },
    infoHidden: false,
  };

  onControlledDrag = (_, position) => {
    const { x, y } = position;

    const newPosition = {
      x: x,
      y: y,
    };

    this.props.setTextPosition({
      x,
      y,
    });
    this.setState({ controlledPosition: newPosition });
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.textPosition.x !== prevProps.textPosition.x ||
      this.props.textPosition.y !== prevProps.textPosition.y
    ) {
      const newPosition = {
        x: this.props.textPosition.x,
        y: this.props.textPosition.y,
      };

      this.setState({ controlledPosition: newPosition, infoHidden: true });
    }
  }

  getCurrentDateTime = () => {
    const now = new Date();
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const month = months[now.getMonth()];
    const day = String(now.getDate()).padStart(2, "0");
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    return `${month} ${day} ${year} ${hours}:${minutes}:${seconds}`;
  };

  render() {
    const { controlledPosition, infoHidden } = this.state;

    return (
      <Draggable
        nodeRef={this.nodeRef}
        axis="both"
        bounds="parent"
        handle=".text-handle"
        scale={1}
        position={controlledPosition}
        onStart={this.handleStart}
        onDrag={this.onControlledDrag}
        onStop={this.handleStop}
        disabled={this.props.isDetailMode}
      >
        <div className="absolute bottom-0" ref={this.nodeRef}>
          <div className="relative w-fit">
            <div
              className={`select-none box-border text-gray-500 ${
                this.props.isDetailMode ? "" : "border-2 border-green-600"
              }`}
              style={{
                fontSize: "6px",
                lineHeight: "1.5",
                padding: "2px 4px",
                backgroundColor: "rgba(255, 255, 255, 0.9)",
                color: "#808080",
                fontFamily: "serif",
                fontWeight: "bold",
              }}
            >
              <div>Dokumen ini telah ditandatangani melalui</div>
              <div>Paperless</div>
              {/* <div>Ditandatangani pada: {this.getCurrentDateTime()}</div> */}
              <div>Penandatangan: XYZ</div>
            </div>
            <div
              className={`absolute flex justify-center items-center w-full h-full top-0 left-0 bg-transparent text-handle cursor-move ${
                this.props.isDetailMode ? "hidden" : ""
              }`}
            >
              <div
                className={`bg-white w-16 text-green-600 text-xs text-center font-semibold select-none ${
                  infoHidden || this.props.isDetailMode ? "hidden" : ""
                }`}
              >
                Drag text
              </div>
            </div>
          </div>
        </div>
      </Draggable>
    );
  }
}
